/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../app/app-admin.component';
const styles_AppAdminComponent:any[] = [i0.styles];
export const RenderType_AppAdminComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AppAdminComponent,data:{}});
export function View_AppAdminComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export function View_AppAdminComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-admin-root',
      ([] as any[]),(null as any),(null as any),(null as any),View_AppAdminComponent_0,
      RenderType_AppAdminComponent)),i1.ɵdid(1,49152,(null as any),0,i3.AppAdminComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const AppAdminComponentNgFactory:i1.ComponentFactory<i3.AppAdminComponent> = i1.ɵccf('app-admin-root',
    i3.AppAdminComponent,View_AppAdminComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvYXBwLWFkbWluLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2FwcC1hZG1pbi5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvYXBwLWFkbWluLmNvbXBvbmVudC50cy5BcHBBZG1pbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cbiIsIjxhcHAtYWRtaW4tcm9vdD48L2FwcC1hZG1pbi1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBOzBEQUFBO1VBQUEsNkJBQStCOztRQUEvQjs7OztvQkNBQTtNQUFBO2tDQUFBLFVBQUE7TUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app-admin.component.ngfactory.ts